import React from 'react';
import { Mail, Linkedin, Instagram, Briefcase, Github } from 'lucide-react';
import './Footer.css';

const Footer = () => {
    return (
        <footer>
            <div className="social-links">
                <a
                    href="mailto:hamzaekhwan2000@gmail.com"
                    className="social-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Email"
                >
                    <Mail size={20} />
                </a>
                <a
                    href="https://www.linkedin.com/in/hamza-ekhwan/"
                    className="social-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                >
                    <Linkedin size={20} />
                </a>
                <a
                    href="https://github.com/hamzaekhwan"
                    className="social-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="GitHub"
                >
                    <Github size={20} />
                </a>
                <a
                    href="https://instagram.com/hamzaekhwan?igshid=YmMyMTA2M2Y="
                    className="social-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                >
                    <Instagram size={20} />
                </a>
                <a
                    href="https://khamsat.com/user/hamzaekhwan"
                    className="social-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Portfolio"
                >
                    <Briefcase size={20} />
                </a>
            </div>
            <p>&copy; 2026 Hamza Ekhwan. All rights reserved.</p>
        </footer>
    );
};

export default Footer;